<template>
  <div class="grey-bg">
    <div>
      <span class="time">
        <strong style="font-size: 1rem"
          >{{ time.split(/[-T:]/)[3] }}:{{ time.split(/[-T:]/)[4] }}</strong
        >
        <span style="margin-left: 5px" v-html="depart ? '発' : '着'"></span>
      </span>
      <span class="circle"></span>
      <span class="port_name">{{ busstopName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayTimeAndBusstop",
  props: {
    busstopName: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    depart: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {},
};
</script>

<style scoped lang="scss">
.grey-bg {
  background: #f9f9f9;
  padding: 0;
  padding-left: 10px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  height: 35px;
  position: relative;
}

.grey-bg div {
  position: absolute;
  top: 50%;
  width: 95%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

span {
  display: inline-block;
}
.time {
  width: 25%;
}
.circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #888888;
  margin-right: 10px;
}
.port_name {
  font-weight: bold;
  width: 65%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
